export enum EmergencyLogMessages {
  REGULAR_EMERGENCY_CALL = 'Regular emergency call',
  SPAWN_EMERGENCY_CALL = 'Spawn emergency call',
  DIALBACK_EMERGENCY_CALL = 'Dialback emergency call',
}
